import { ColorSpec } from "designSystem/components/colorchip/ColorChipArrayStore";
import { ColorChipArray, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import blackImage from "./Black.jpg";
import blueImage from "./Blue.jpg";
import greyImage from "./Grey.jpg";

export default () => {
	const colors: ColorSpec[] = [];
	const errorColors: ColorSpec[] = [
		{
			id: "1",
			name: "No Image",
		},
		{
			id: "2",
			name: "Blue",
			image: "xxx",
		},
	];

	const invalidColors: ColorSpec[] = [
		{
			id: "Blue",
			name: "Blue",
			image: blueImage,
			hasViolation: true,
		},
		{
			id: "Black",
			name: "Black",
			image: blackImage,
			hasViolation: true,
		},
		{
			id: "Grey",
			name: "Grey",
			image: greyImage,
			hasViolation: true,
		},
	];

	const name = useLocale()
		.resource("DefaultColor");

	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="empty" />
			<Text semiBold text="default" />
			<Text semiBold text="error" />
			<Text semiBold text="invalid" />
			<ColorChipArray colors={colors} />
			<ColorChipArray colors={colors} defaultColor={{ name }} />
			<ColorChipArray colors={errorColors} defaultColor={{ name }} />
			<ColorChipArray colors={invalidColors} defaultColor={{ name }} />
		</CssColumnGrid>
	);
};